import { RoutePath } from 'src/types/path';

export const paths: RoutePath = {
  auth: {
    login: '/auth/login',
  },
  consentForms: {
    root: '/consent-forms',
    detail: {
      patientConsents: '/consent-forms/:patientId/patient-consents',
      // 患者ID(registration_number)からの外部連携エントリ専用ルート。クエリパラメータ
      // ?registration-number=... で受け取り、内部idへ解決後にpatientConsentsへ
      // router.replaceする（patientConsents自体は内部id専用のまま変更しない）。
      patientConsentsByRegistrationNumber: '/consent-forms/patient-consents',
      templates: '/consent-forms/:patientId/templates',
      register: '/consent-forms/:patientId/register',
      displayMethod: '/consent-forms/:patientId/display-method',
      import: '/consent-forms/import',
      signedHistoryUrl: '/consent-forms/:patientId/signed-history-url',
      signature: {
        root: '/consent-forms/:patientId/signature',
        complete: '/consent-forms/:patientId/signature/complete',
      },
    },
  },
  patients: {
    root: '/patients',
    register: '/patients/register',
    detail: {
      edit: '/patients/:id/edit',
    },
  },
  templates: {
    root: '/templates',
    register: '/templates/register',
    detail: {
      edit: '/templates/:id/edit',
    },
  },
  defaultDoctor: {
    root: '/default-doctor',
  },
  users: {
    root: '/users',
    register: '/users/register',
    csvImport: {
      root: '/users/csv-import',
      history: '/users/csv-import/history',
    },
    detail: {
      edit: {
        root: '/users/:id/edit',
        delete: {
          complete: '/users/:id/delete/complete',
        },
        update: {
          complete: '/users/:id/update/complete',
        },
      },
    },
  },
  organization: {
    root: '/organization',
  },
  myAccount: {
    root: '/my-account',
    changePassword: {
      root: '/my-account/change-password',
      complete: '/my-account/change-password/complete',
    },
  },
  error: {
    404: '/404',
  },
  contact: {
    root: '/contact',
  },
};
